export const customInputRules = (rulesObj = {}) => {
  const rules = [];
  if (rulesObj.required) {
    const reqFunc = (val) => !!val || "Это поле обязательно";
    rules.push(reqFunc);
  }
  return rules;
};
